import { Activity } from "PFTypes";

import css from "./content.module.scss";
import { Description } from "./description";

type OpenGraphMetadata = {
  image?: string;
  title?: string;
  description?: string;
};

type PostContentBodyProps = {
  activity: Activity;
  og?: OpenGraphMetadata;
};

export const PostContentBody = ({ activity, og }: PostContentBodyProps) => {
  if (!og) {
    return (
      <div className={css.singlePost}>
        <Description description={activity.description} descriptionLength={300} />
      </div>
    );
  }

  return (
    <>
      <div className={css.postDescription}>
        <Description description={activity.description} descriptionLength={300} />
      </div>
      {og.image && <img src={og.image} className={css.image} alt="" />}
      <div className={css.postTitle}>{og.title}</div>
      <div className={css.postText}>
        <Description description={og.description || ""} descriptionLength={300} />
      </div>
    </>
  );
};
